import React from 'react';
import { Grid } from '@material-ui/core';
import { AxiosError, AxiosResponse } from 'axios';

import { PowerBIDashboard } from '../components/PowerBIDashboard';
import { DashboardStatus } from '../enums/DashboardStatus';
import { DashboardContext } from '../DashboardContext';
import { DashboardLoading } from '../components/DashboardLoading';
import { EmbedParamsModel, embedParamsModelInitial } from '../../../Models/EmbedParamsModel';
import PowerBIService from '../../../Services/PowerBIService';
import { DashboardError } from '../components/DashboardError';
import { IErrorResponse } from '../../../shared/ErrorResponse';
import { ErrorHelper } from '../../../shared/ErrorHelper';
import { HomeContext } from '../../Home/HomeContext';

export function DashboardColgate() {
    const homeContext = React.useContext(HomeContext);

    const [dashboardStatus, setDashboardStatus] = React.useState<DashboardStatus>(DashboardStatus.DEFAULT);
    const [embedParams, setEmbedParamas] = React.useState<EmbedParamsModel>(embedParamsModelInitial);
    const [errorMessage, setErrorMessage] = React.useState<string>('');

    React.useEffect(() => {
        if (dashboardStatus === DashboardStatus.DEFAULT){
            setDashboardStatus(DashboardStatus.LOADING);

            PowerBIService.colgatePowerBIService()
                .getAll()
                .then((res: AxiosResponse) => {
                    setEmbedParamas(res.data);
                    
                    if (res.data.embedReport.pageName != '')
                        setDashboardStatus(DashboardStatus.DONE);
                    else {
                        setDashboardStatus(DashboardStatus.ERROR);
                        homeContext.showError('Não há nenhum cliente vinculado ao usuário. Atualize o campo de clientes do usuário para visualizar essa página.');
                    }
                })
                .catch((error: AxiosError) => {
                    const errorResponse: IErrorResponse = ErrorHelper(error);
                    setErrorMessage(errorResponse.message);
                    setDashboardStatus(DashboardStatus.ERROR);
                });
        }
    }, [dashboardStatus]);

    return (
        <DashboardContext.Provider value={{
            dashboardStatus, setDashboardStatus,
            embedParams, setEmbedParamas,
            errorMessage, setErrorMessage
        }}>
            <Grid 
                container 
                justify="center" 
                alignItems="center">
                <Grid
                    container
                    direction="column"
                    alignItems="stretch"
                    justify="center">
                    <Grid item xs={12}>
                        {dashboardStatus === DashboardStatus.LOADING && <DashboardLoading />}
                        {dashboardStatus === DashboardStatus.DONE && <PowerBIDashboard />}
                        {dashboardStatus === DashboardStatus.ERROR && <DashboardError />}
                    </Grid>
                </Grid>
            </Grid>
        </DashboardContext.Provider>
    );
}